/**
 * **Un poids en octets, tel qu'une personne le lit.**
 *
 * `CDC-3` F-36 fixe **deux unités, et elles coexistent sur le même objet** : « le
 * **pourcentage en permanence**, sur la jauge ; le **volume au moment du refus**, qui porte
 * la place restante et ce que le dépôt demande. **Un pourcentage ne dit pas si un document
 * de trois mégaoctets entre ; un volume ne se lit pas d'un coup d'œil.** » Cette fonction
 * sert la seconde, et `pourcentageDeRemplissage` de `shared/lib` sert la première.
 *
 * **Les préfixes sont décimaux, pas binaires** — Mo et non Mio. C'est ce que dit un
 * système d'exploitation grand public, et c'est donc ce qu'une personne compare au poids
 * qu'elle lit dans son explorateur de fichiers. Afficher 1,91 Mio là où sa machine dit
 * 2 Mo ferait douter du compte.
 */
const PALIERS = [
  { seuil: 1_000_000_000, unite: 'Go', diviseur: 1_000_000_000 },
  { seuil: 1_000_000, unite: 'Mo', diviseur: 1_000_000 },
  { seuil: 1_000, unite: 'ko', diviseur: 1_000 },
] as const;

export function poidsLisible(octets: number): string {
  if (octets <= 0) return '0 o';
  for (const palier of PALIERS) {
    if (octets >= palier.seuil) {
      const valeur = octets / palier.diviseur;
      // Une décimale sous dix, aucune au-dessus : « 1,4 Go » se lit, « 1 432 Mo » se
      // compte, et personne ne compte.
      const arrondi = valeur < 10 ? valeur.toFixed(1) : Math.round(valeur);
      return `${String(arrondi).replace('.', ',')} ${palier.unite}`;
    }
  }
  return `${octets} o`;
}
